// For a GitHub source deployment, point this build variable at the EXE asset
// in GitHub Releases. The Netlify source package includes the actual file.
export const compareDeskRelease = {
  version: "1.1.1",
  eulaUrl: "/downloads/CompareDesk-1.1.1-EULA.pdf",
  platform: "Windows 64-bit",
  filename: "CompareDesk-1.1.1-Portable.exe",
  bytes: 123867482,
  size: "118.1 MB",
  updated: "17 October 2026",
  checksum: "E1BE2210FD00CC689604D9B730B3BABDD2C84AB175DE049C7F536B772B6EFDDB",
  email: "comparedesk@annotastudio.com",
  url: (import.meta as ImportMeta & { env: Record<string, string> }).env.VITE_COMPAREDESK_DOWNLOAD_URL || "/downloads/CompareDesk-1.1.1-Portable.exe",
};
